import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="home page">
      <div className="container">
        <div className="home__content">
          <h2 className="home__title">Home page</h2>
          <p className="home__text">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam incidunt, alias sequi id
            iusto qui laboriosam esse voluptas molestias itaque quo ipsa repellat adipisci ipsam.
          </p>
          <p className="home__descr">
            <Link to="/inbox">
              <button className="btn btn-primary">Inbox</button>
            </Link>
            <Link to="/completed">
              <button className="btn btn-primary">Completed</button>
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
